// Import Standards
import axios from "axios";
import { useEffect, useState } from "react";

// Bulma Components
import { Image, Columns } from "react-bulma-components";

// Photos Component
const Photos = (props) => {
    // photo arrays
    const [photos, setPhotos] = useState([]);

    // Fetch data from API to Photos state
    useEffect(() => {
        axios.get(`https://api.pexels.com/v1/search?query=${props.location},${props.name}&per_page=9&page=1&orientation=landscape`, {headers: {"Authorization": "563492ad6f917000010000014a9ce0df9fb54c3280ea828d0eea1ca2", "X-Ratelimit-Limit": 20000,
        "X-Ratelimit-Remaining": 19684,
        "X-Ratelimit-Reset": 1590529646,
        "Access-Control-Allow-Origin": "*"}})
        .then(response => {
            let data = response.data.photos;
            setPhotos(data);
            // console.log(photos);
        }).catch(error => console.error(error));
    }, [props.location, props.name]);

    // Map photos into Image element
    const photoGrid = photos.map((photo, i) => {
        return <Image className="column is-4" kind="child" key={`photo${i}`} src={photo.src.medium}/>;
    });

    return (
        <Columns>
            {/* return photos as array of image element */}
            {photoGrid}

        </Columns>
    );
}

export default Photos;